import { IDisputeTrackingStatusRepositoryResponse } from "@/core/repositories/lookup";
import { LookupRepository } from "@/infrastructure/repositories/lookup";

export class GetDisputeTrackingStatusUseCase {
  constructor(private readonly lookupRepository: LookupRepository) {}

  async execute(): Promise<IDisputeTrackingStatusRepositoryResponse> {
    return this.lookupRepository.getDisputeTrackingStatuses();
  }
}
